const EMPTY_MATERIALS = Object.freeze({
  yarn: '',
  needles: '',
  other: Object.freeze([]),
});

export function normalizeMaterials(materials) {
  if (!materials || typeof materials !== 'object' || Array.isArray(materials)) {
    return { ...EMPTY_MATERIALS, other: [] };
  }

  return {
    yarn: typeof materials.yarn === 'string' ? materials.yarn : '',
    needles: typeof materials.needles === 'string' ? materials.needles : '',
    other: Array.isArray(materials.other)
      ? materials.other.map((item) => (typeof item === 'string' ? item : ''))
      : [],
  };
}

export function addOtherMaterial(materials) {
  const normalized = normalizeMaterials(materials);
  return { ...normalized, other: [...normalized.other, ''] };
}

export function updateOtherMaterial(materials, index, value) {
  const normalized = normalizeMaterials(materials);
  return {
    ...normalized,
    other: normalized.other.map((item, itemIndex) => (
      itemIndex === index ? value : item
    )),
  };
}

export function removeOtherMaterial(materials, index) {
  const normalized = normalizeMaterials(materials);
  return {
    ...normalized,
    other: normalized.other.filter((_, itemIndex) => itemIndex !== index),
  };
}
